<div class="habits-calendar-container">
  <div class="calendar-header">
    <h3 class="calendar-title">Habits</h3>
    <div class="month-year-selector">
      <mat-form-field appearance="outline" class="month-select">
        <mat-label>Month</mat-label>
        <mat-select [(ngModel)]="selectedMonth" (selectionChange)="onMonthYearChange()">
          <mat-option *ngFor="let month of months; let i = index" [value]="i" [disabled]="isMonthDisabled(i)">
            {{ month }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="year-select">
        <mat-label>Year</mat-label>
        <mat-select [(ngModel)]="selectedYear" (selectionChange)="onMonthYearChange()">
          <mat-option *ngFor="let year of years" [value]="year" [disabled]="isYearDisabled(year)">
            {{ year }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="month-year-display">
    <h4>{{ months[selectedMonth] }}, {{ selectedYear }}</h4>
  </div>

  <div class="calendar-grid" *ngIf="!isLoading">
    <div class="calendar-day-header">
      <div class="day-header-cell" *ngFor="let dayName of ['SUN', 'MON', 'TUE', 'WED', 'THUR', 'FRI', 'SAT']">
        {{ dayName }}
      </div>
    </div>

    <div class="calendar-days">
      <div
        class="calendar-day-cell"
        *ngFor="let day of calendarDays"
        [class.empty-day]="!day.isCurrentMonth"
        [class.has-entries]="day.isCurrentMonth && (day.entries ?? 0) > 0"
        (click)="onDayClick(day)"
      >
        <div *ngIf="day.isCurrentMonth" class="day-content">
          <div class="day-date">{{ months[selectedMonth].substring(0, 3) }} {{ day.day }}</div>
          <div class="day-entries">
            <span>{{ day.entries ?? 0 }} Entries</span>
          </div>
        </div>

        <div *ngIf="day.isCurrentMonth" class="habit-hover-card">
          <div class="habit-hover-row">
            <span class="habit-hover-label">Habit assigned</span>
            <span class="habit-hover-value">{{ day.entries ?? 0 }}</span>
          </div>
          <div class="habit-hover-row">
            <span class="habit-hover-label">Completed Habit</span>
            <span class="habit-hover-value">{{ day.completed ?? 0 }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner diameter="50"></mat-spinner>
    <p>Loading habits...</p>
  </div>
</div>

